var app = angular.module('directives.paymentFields');

app.directive('paymentFields', [
    'configs',
    '$state',
    '$rootScope',
    'Iban',
    'AmountCommission',
    function (configs, $state, $rootScope, Iban, AmountCommission) {
        var tmplUrl;

        try {
            tmplUrl = require('../templates/' + $state.current.name.replace('pages.', '') + '.html');//looking for template with moduleName
        } catch (e) {
            tmplUrl = require('../templates/index.html')//if error, use default template
        }

        var parsedLink = $state.current.url.split("/");
        parsedLink.forEach(function (key) {
            if (key == 'l') {
                tmplUrl = require('../templates/index.html');
            }
            if (key == 'ls') {
                tmplUrl = require('../templates/service.html');
            }
        });

        return {
            template: tmplUrl,
            controller: 'fieldsCtrl',
            scope: {
                'fields': '=',
                'form': '='
            },
            link: function (scope) {
                scope.periodSelected = function (type, value) {
                    switch (type) {
                        case 'PERIOD_END':
                            var fieldStart = scope.fields.find(function (field) {
                                return field.alias == 'PERIOD_START'
                            });
                            fieldStart.periodOptions['maxDate'] = value;
                            break;

                        case 'PERIOD_START':
                            var fieldEnd = scope.fields.find(function (field) {
                                return field.alias == 'PERIOD_END';
                            });
                            fieldEnd.periodOptions['minDate'] = value
                            break;

                        default:
                            break;
                    }
                }
            }
        }

    }
]);

app.controller('fieldsCtrl', function ($rootScope, $scope, Pay, Combobox, Counters, Iban, AmountCommission, configs) {
    $scope.pay = Pay;
    $scope.Combobox = Combobox;
    $scope.iban = Iban;
    $scope.MFOfield = {};
    $scope.configs = configs;
    $scope.openedStart = false;

    $scope.opening = function (open) {
        $scope.isOpen = !open;
    };
    $scope.openDetails = function (open) {
        $scope.isOpenDetails = !open;
    };

    $scope.selectProduct = function (product, mUnit) {
        if ($scope.pay.innerState === 'create') {
            Counters.selectProduct(product, mUnit);
        }
    }

    function init () {
        if($scope.fields) {
            $scope.fields.forEach(function(field) {
                switch (field.alias.toUpperCase()) {
                    case 'AMOUNT':
                        $scope.pay.amount = $scope.pay.amountInput = field.value;
                        AmountCommission.countAmount();
                        break;
                    case 'MFO':
                        $scope.MFOfield = field;
                        break;
                    case 'COUNTER':
                        if(field.values && Array.isArray(field.values)) {
                            field.values.forEach(function (val) {
                               if(val.tariff) {
                                   val.tariff = val.tariff/100 || 0;
                               }
                            });
                        }
                        break;
                }
                if(field.type === 'PERIOD' && (!field.periodOptions && !$scope.pay.data.periodOptions)) {
                    field.periodOptions = field.template && field.template.includes('DD') ?  {minMode:'day'} : {minMode:'month'};
                }
            })
        }
    };

    $scope.selectedField = function(field) {

        if(field.value){
            field.values.forEach(function (item) {
                if( item.id == field.value ) {
                    field['select_value'] = item.name;
                }
            })
        }

        Pay.selectedFieldsOnCheck[field.alias] = findSelectedValue(field.alias, field.value, Pay.defaultFields);

        for (var i = 0; i < Pay.defaultFields.length; i++) {
            if (Pay.defaultFields[i].dependency) {
                Pay.defaultFields[i].dependency.forEach(function (d) {
                    if (Pay.selectedFieldsOnCheck[d]) {
                        Pay.fields[i].values = findFieldDependency(Pay.defaultFields[i], Pay.selectedFieldsOnCheck[d].ref[Pay.defaultFields[i].alias]);
                    }
                })
            }
            }
    };

    function findSelectedValue(alias, id, fields) {
        var val;
        for (var i = 0; i < fields.length; i++) {
            if (fields[i].alias == alias) {
                fields[i].values.forEach(function (v) {
                    if (v.id == id) {
                        val = angular.copy(v);
                    }
                })
            }
        }
        return val;
    }

    function findFieldDependency(field, dependency) {
        var newArr = [];

        for (var i = 0; i < field.values.length; i++) {
            dependency.forEach( function(id) {
                if (field.values[i].id == id) {
                    newArr.push(field.values[i])
                }
            })
        }

        return newArr;
    }

    $scope.toggleDatepicker = function (field) {
        console.log('toggleDatepicker', $scope.openedStart);//TODO: Delete
        if(field.restriction !== 'RO') {
            $scope.openedStart = !$scope.openedStart;
        }
    }

    $scope.checkIbanAccount = function(value) {
        if ($scope.iban.isValidIBAN(value)) {
            $scope.MFOfield.value = value.substr(4, 6);
            $scope.MFOfield.restriction = 'RO';
        } else {
            $scope.MFOfield.restriction = 'ED';
        }
    }

    $rootScope.$on("CallSelectedField", function(field){
        $scope.selectedField(field);
    });

    init();
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentFields/directives/paymentFields.js
 ** module id = 202
 ** module chunks = 1
 **/